import { render, staticRenderFns } from "./WIN_glBancos.vue?vue&type=template&id=f4ad8fcc&"
import script from "./WIN_glBancos.vue?vue&type=script&lang=js&"
export * from "./WIN_glBancos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports